import { configureStore } from '@reduxjs/toolkit'
import tokenReducer from '../features/token/token'
import inputReducer from '../features/inputs/inputs'
import sessionReducer from '../features/session/sessionId'
import outputReducer from '../features/outputs/outputs'
import incentiveSearchReducer from '../features/incentiveSearch/search'
import analysisPageNavReducer from '../features/analysisPageNav/analysisPageNav'
import freshRunReducer from '../features/freshRun/freshRun'
import accessGateReducer from '../features/accessGate/accessGate'
import { loadState } from '../localStorage'

const preloadedStateToken = loadState("token");
const preloadedStateInputs = loadState("inputs");
const preloadedStateSession = loadState("sessionId");
const preloadedStateOutputs = loadState("outputs");
const preloadedIncentiveSearch = loadState("incentiveSearch");
const preloadedFreshRun = loadState("freshRun");
const preloadedAccessGate = loadState("accessGate");

const preloadedState = {
  token: preloadedStateToken,
  inputs: preloadedStateInputs,
  sessionId: preloadedStateSession,
  outputs: preloadedStateOutputs,
  incentiveSearch: preloadedIncentiveSearch,
  analysisPageNavReducer: 'costs',
  freshRun: preloadedFreshRun,
  accessGate: preloadedAccessGate,
}

export default configureStore({
  reducer: {
    token: tokenReducer,
    inputs: inputReducer,
    sessionId: sessionReducer,
    outputs: outputReducer,
    incentiveSearch: incentiveSearchReducer,
    analysisPageNav: analysisPageNavReducer,
    freshRun: freshRunReducer,
    accessGate: accessGateReducer,
  },
  preloadedState: preloadedState ? preloadedState : undefined
})